export const styles = {
	mainContainer: {
		display: 'flex',
		'@media (max-width: 600px)': {
			flexDirection: 'column',
			gap: '2rem',
		},
	},
	container: {
		alignItems: 'center',
		'& svg': {
			width: '225px',
		},
		'@media (max-width: 900px) and (min-width: 601px)': {
			'& svg': {
				width: '107px',
			},
		},
	},
	cardsContainer: {
		display: 'flex',
		justifyContent: 'left',
		'@media (max-width: 1000px)': {
			alignItems: 'center',
		},
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #C8003C 51%, #FF437B 100%)',
	},
	rectangle: {
		height: '48px',
		width: '208px',
		border: '1px solid #0000003B',
		borderRadius: '4px',
		justifyContent: 'center',
		alignItems: 'center',
	},
	circularProgressIcon: {
		color: 'secondary.main',
	},
	loadingText: {
		paddingLeft: '10px',
	},
	cards: {
		display: 'flex',
	},
	extremeGroupContainer: {
		bgcolor: '#FFDDE7',
		padding: '1rem',
	},
	extremeGroupLabel: {
		fontWeight: 700,
		fontSize: 14,
		color: '#45657B',
		marginBottom: '0.5rem',
	},
	extremeGroupDivider: {
		margin: '1rem 0',
		borderColor: 'rgba(0, 0, 0, 0.12)',
	},
	extremeIdeaItem: {
		opacity: 0.87,
		margin: '10px 0',
		fontSize: 16,
		color: 'black',
	},
	leftArrow: {
		boxSizing: 'border-box',
		width: '170px',
		height: '1px',
		transform: 'rotate(180deg)',
		/* Inside auto layout */
		flex: 'none',
		order: 5,
		flexGrow: 0,
	},
}
